import React, { ReactElement } from "react";
import { Box, Typography } from "@mui/material";
import enumStrings, { RoutePaths } from "../../../enumStrings";
import { commonStyles } from "../../common/commonStyles";
import Button from "../../common/Button";
import { useNavigate } from "react-router-dom";

const ErrorBasePage = ({
  title,
  subtitle,
  description,
  emailSubject,
}: {
  title: string;
  subtitle: string;
  description: string;
  emailSubject: string;
}): ReactElement => {
  const navigate = useNavigate();

  return (
    <Box
      sx={{
        minHeight: "100vh",
        width: "100%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        bgcolor: "white",
        flexDirection: "column",
        textAlign: "center",
        pl: 2,
        pr: 2,
      }}
    >
      <Box sx={{ maxWidth: "850px" }}>
        <Typography variant="h2" sx={{ fontWeight: 500 }}>
          {title}
        </Typography>
        <Typography variant="h2" sx={{ fontWeight: 500 }}>
          {subtitle}
        </Typography>
        <Typography sx={{ fontSize: commonStyles.fontSizes.large, mt: 2 }}>
          {description}
        </Typography>
        <Box
          sx={{
            display: "flex",
            gap: 2,
            mt: 6,
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Button
            text={enumStrings.pages.common.buttons.homeButtonText}
            onClick={() => navigate(RoutePaths.home)}
            size="medium"
          />
          <Button
            text={enumStrings.pages.common.buttons.contactSupportButtonText}
            onClick={() =>
              (window.location.href = `mailto:${enumStrings.supportContactEmail}?subject=${emailSubject}&body=Please%20state%20your%20issue%20below.`)
            }
            size="medium"
          />
        </Box>
      </Box>
    </Box>
  );
};

export default ErrorBasePage;
